import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const AnchorBgTitles = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.anchorBgTitles.title')}
      contentType="anchorBgTitles"
      description={t('page.anchorBgTitles.desc')}
      outputLabel={t('page.anchorBgTitles.output')}
    />
  );
};
